var _       = require('underscore');
var $       = require('jquery');
var Core    = require('../core/core.js');
var DashboardItemButton = require('./dashboard__listcomponents__item__btn.js');

/**
 * Creates an overlay tray large component item
 *
 * @class
 */

class DashboardListComponentsItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                "name": '',
                "description": '',
                "thumb_url": '',
                "updated_at": '',
                "document_id": ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__dashboard__listcomponents__item">
              <div class="editor__dashboard__listcomponents__item__thumbnail js-editor__dashboard__listcomponents__item__thumbnail">
                <img src="<%= external_url(thumb_url) %>" />
              </div>
              <div class="editor__dashboard__listcomponents__item__details">
                <div class="editor__dashboard__listcomponents__item__name"><%- name %></div>
                <div class="editor__dashboard__listcomponents__item__updatedAt"><%- updated_at.displayDate %></div>
              </div>
              <div class="editor__dashboard__listcomponents__item__btns js-editor__dashboard__listcomponents__item__btns">
              </div>
            </div>
        `;

        super.render();

        $(".js-editor__dashboard__listcomponents__item__thumbnail > img", this.$el).on('error', this._thumbnailFail);

    }

    addButton(text) {
      return new DashboardItemButton({
        target: $('.js-editor__dashboard__listcomponents__item__btns', this.$el),
        fields: {
          'text': text
        }
      });
    }

    _thumbnailFail(e) {
      e.preventDefault();
      $(e.currentTarget).hide();
    }

}
module.exports = DashboardListComponentsItem;
